import React from 'react'
import { MdOutlineBarChart } from "react-icons/md";
import { IoDocumentText } from "react-icons/io5";
import { FaPen } from "react-icons/fa";
import { FaSwatchbook } from "react-icons/fa6";
import { CiExport } from "react-icons/ci";
import BoxWrapper from './BoxWrapper';






function DashboardStatsGrid() {
    return (
        <div className='flex /*gap-4 w-full*/'>
        <BoxWrapper title={'Available Reports'}>
            <div className='flex-1'>
                <div className='mb-1 flex items-center justify-end'>
                    {/* <span className='text-lg text-stone-900 font-semibold'>Available Reports</span> */}
                    <div className='border py-2 px-4 rounded-lg flex items-center hover:cursor-pointer hover:bg-slate-100'>
                        <CiExport />
                        <span className='pl-2 text-sm'>Export</span>
                    </div>
                </div>
                <span className='text-sm text-stone-500 font-normal'>These are sample reports for you</span>
                <div className='mt-10 flex gap-6 flex-row'>
                    <div className='flex bg-[#FFE2E5] rounded-lg p-6 flex-col'>
                        <div className='rounded-full p-2 bg-[#FA5A7D] w-12 h-12 flex items-center justify-center'>
                            <MdOutlineBarChart className='size-6 text-white'/>
                        </div>
                        <span className='text-3xl font-bold mt-4'>200</span>
                        <span className='font-light text-lg mt-2'>Total Tests</span>
                        <span className='text-sm text-blue-600 mt-1'>+8% from yesterday</span>
                    </div>

                    <div className='flex bg-[#FFF4DE] rounded-lg p-6 flex-col'>
                        <div className='rounded-full p-2 bg-[#FF947A] w-12 h-12 flex items-center justify-center'>
                            <IoDocumentText className='size-6 text-white'/>
                        </div>
                        <span className='text-3xl font-bold mt-4'>8</span>
                        <span className='font-light text-lg mt-2'>Total Tests</span>
                        <span className='text-sm text-blue-600 mt-1'>+5% from yesterday</span>
                    </div>

                    <div className='flex bg-[#DCFCE7] rounded-lg p-6 flex-col'>
                        <div className='rounded-full p-2 bg-[#3CD856] w-12 h-12 flex items-center justify-center'>
                            <FaPen className='size-6 text-white'/>
                        </div>
                        <span className='text-3xl font-bold mt-4'>23</span>
                        <span className='font-light text-lg mt-2'>Total Tests</span>
                        <span className='text-sm text-blue-600 mt-1'>+11% from yesterday</span>
                    </div>

                    <div className='flex bg-[#F3E8FF] rounded-lg p-6 flex-col'>
                        <div className='rounded-full p-2 bg-[#BF83FF] w-12 h-12 flex items-center justify-center'>
                            <FaSwatchbook className='size-6 text-white'/>
                        </div>
                        <span className='text-3xl font-bold mt-4'>11</span>
                        <span className='font-light text-lg mt-2'>Total Tests</span>
                        <span className='text-sm text-blue-600 mt-1'>+1.3% from yesterday</span>
                    </div>
                </div>
            </div>
        </BoxWrapper>
   

    </div>
  )
}

export default DashboardStatsGrid
